import React from 'react'
//import CONSTANTS from '../../constants'

import './footer.scss'
import CONSTANTS from '../../Constants'
import { useLocation } from 'react-router-dom'

const Footer = () => {
  const { pathname } = useLocation()
  // Initializing Layer
  const _LabelByStep = () => {
    switch(pathname){
      /*case CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE :
        return window.labels.dealer_locator_footer ? <div id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.dealer_locator_footer }} /> : ''*/
      case CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.multislots_footer }} />
      case CONSTANTS.SITE_ROUTS.VEHICLEPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.vehicule_footer }} />
      case CONSTANTS.SITE_ROUTS.OPERATIONSPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.needs_footer }} />
      case CONSTANTS.SITE_ROUTS.YOURQUOTEPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.quote_footer }} />
      case CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.userinfos_footer }} />
      case CONSTANTS.SITE_ROUTS.SUMMARYPAGE :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.summary_footer }} />
      case CONSTANTS.SITE_ROUTS.CONFIRMATION :
        return <div tabIndex="0" id='legal_notice' dangerouslySetInnerHTML={{ __html: window.labels.confirm_footer }} />
      default :
        return  ''
    }
  }
  return (
    <footer>
      <div tabIndex="0" id='legal' dangerouslySetInnerHTML={{ __html: CONSTANTS.SITE_INFO.GDPR }}>
      </div>
      {_LabelByStep()}
    </footer>
  )
}

export default Footer
